import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {SimpleSearch, SimpleSearchWithId, SearchByFilters, SearchByFiltersCustom} from "../../../../../reduxToolkit/Search/SearchApi";
import {useTranslation} from "react-i18next";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../../Routes/routes";
import {
    DetailsIconsOptions,
    IconClockTable,
    IconQr,
    IconScheduleTable,
    NextIconsOptions,
    PersonOutlinedChip
} from "../../../../../components/buttons/IconButtons";
import TableFunction from "../../../../../components/table/TableFunction";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat, getTimeFormat} from "../../../../../Apis/functions";
import {
    CRITERIA_MODEL,
    SEARCH_MODEL
} from "../../../../../components/table/Model/TableModel";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import {useNavigate} from "react-router-dom";
import CustomImageTable from "../../../../../components/CustomImageTable";
import {USER_TYPE_NAME_MODEL} from "../../../../../enums/userTypeEnum";
import {colors} from "../../../../../enums/colors";
import {
    downloadMaterialControlQrCode,
    getEntryAndExitFormByType,
    getMaterialRequestTableStatusId,
    hasMaterialControlQrCode,
    MATERIAL_CONTROL_TABS
} from "../../Model/Model";
import {TABLES} from "../../../../../Apis/Tables";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const EntryAndExitFormsTableApp = ({
    selectedList,
    setSelectedList,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
    finalArray,
    modified,
    setModified,
    setCriteria,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { permission, getUserByIdAtEntry, user } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const isGuard = user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD;
    const tableId = "tbl_eae_entry_and_exit_forms";
    const searchId = "txt_eae_search__entry_and_exit_forms";
    const [results, setResults] = useState(null);
    const deletePermission = false;
    const leftPosition = 0;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head" customWidth="155">{t('folio')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_by')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('requested_date')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('status')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item, index) => {
            // A folio already approved is read with its own status
            const statusId = getMaterialRequestTableStatusId(item);
            const form = getEntryAndExitFormByType(item?.type);
            return (
                [
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        {/* The folio is read cut when it does not fit the column,
                            so it is displayed whole in the tooltip of the cell. */}
                        <CustomTooltip
                            text={item?.code}
                            placement={'top'}
                        >
                            <span className={"text-ellipsis text-ellipsis-cell"}>{item?.code}</span>
                        </CustomTooltip>
                    </CustomTd>,
                    <CustomTd tableId={tableId} >
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={t(form.trans)}
                            icon={form.Icon}
                            classNameIcon={"icon-color-secondary-700 h-16px w-16px"}
                        />
                    </CustomTd>,
                    <CustomTd tableId={tableId} >
                        {item?.title}
                    </CustomTd>,

                    <CustomTd tableId={tableId} >
                        <CustomImageTable
                            tooltip={t(item?.requestedBy)}
                            containerClass={"d-flex"}
                            icon={<div className={`mr-2 d-flex`}><PersonOutlinedChip/></div>}
                        >
                            {t(item?.requestedBy)}
                        </CustomImageTable>
                    </CustomTd>,
                    // The folio is registered at a moment of the day, so the cell
                    // reads the date it was asked for and the time it was
                    // registered at, each one with the icon that names it
                    <CustomTd tableId={tableId} >
                        <div className={'d-flex'}>
                            <IconScheduleTable className={'mr-8px mb-1 icon-color-general-950 fs-14px'}/>
                            <p className='fs-14px'>
                                {getDateFormat(item?.createdAt, null, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                            </p>
                        </div>
                        <div className={'d-flex'}>
                            <IconClockTable className={'mr-8px mb-1 icon-color-general-950'}/>
                            <p className='fs-14px'>
                                {getTimeFormat(item?.createdAt)}
                            </p>
                        </div>
                    </CustomTd>,
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[statusId]}
                            fontColor={statusFontColor[statusId]}
                            borderColor={statusBorderColor[statusId]}
                            legend={t(status[statusId])}
                            variant={'large'}
                        />
                    </CustomTd>,
                ]
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    /**
     * Actions of the row.
     *
     * The guard at the gate only reads the movement it is going to register, so
     * the detail prepared for the gate is the only action it receives, while
     * the requester keeps the tracking of the approval and the QR code.
     */
    const getActionsButtons = (item, index) => {
        const form = getEntryAndExitFormByType(item?.type);

        return <>

                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    { isGuard ?
                        [
                            <DropDownMenuItem
                                id={`dmt_eae_guard_details_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('details')}
                                icon={<DetailsIconsOptions />}
                                url={{
                                    pathname: routes.entryAndExitForms.details + item?.id,
                                    state: { formKey: form.key }
                                }}
                            />
                        ]
                        :
                        [
                            // The tracker is only read when the folio travels an approval flow
                            item?.approvalFlowId &&
                            <DropDownMenuItem
                                id={'btn_eae_approval-tracker' + item.id}
                                index={index}
                                name={t('approval_tracker')}
                                url={{
                                    pathname: `${routes.approvalTracker.main}${TABLES.MATERIAL_CONTROL_REQUEST}/${item?.id}/${item?.approvalFlowId}`,
                                    state: {backUrl: {
                                        pathname: routes.materialControl.main,
                                        state: {
                                            currentTab: MATERIAL_CONTROL_TABS.ENTRY_AND_EXIT_FORMS.INDEX
                                        }
                                    }}
                                }}
                                icon={<NextIconsOptions />}
                            />,
                            <DropDownMenuItem
                                id={`dmt_eae_details_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('details')}
                                icon={<DetailsIconsOptions />}
                                url={{
                                    pathname: routes.entryAndExitForms.details + item?.id,
                                    state: { formKey: form.key }
                                }}
                            />,
                            // The QR code identifies the folio at the gate, so it is
                            // only offered while the gate still has to register it
                            hasMaterialControlQrCode(item) &&
                            <DropDownMenuItem
                                id={`dmt_eae_qr_code_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('qr_code')}
                                icon={<IconQr />}
                                click={() => downloadMaterialControlQrCode(dispatch, item)}
                            />
                        ]
                    }
                </DropDownMenuProfile>

        </>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     *
     * The guard at the gate reads every form already approved and not the ones
     * a user takes part in, so the search travels without the user.
     */
    const getData = (page, criteria) => {
        const key = criteria?.searchElement !== undefined ? criteria?.searchElement : searchElement;
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: key,
            userId: isGuard ? null : getUserByIdAtEntry?.userId,
            view: VIEW_TYPE.LIST.viewType,
        });

        setBodyForExport(body);

        dispatch(isGuard ? SimpleSearch({ body }) : SimpleSearchWithId({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }


    /**
     * Executes a paginated search request using the filters of the advanced search.
     *
     * The filters are read with the same model as the simple search and scoped
     * to the same user, so the table keeps listing the folios the user takes part in.
     */
    const getDataAdvancedSearch = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            // The search scoped to a user is answered by the custom search, the plain
            // one only takes a search without the user to find
            userToFindId: isGuard ? null : getUserByIdAtEntry?.userId,
            view: VIEW_TYPE.LIST.viewType,
        });

        setCriteria(body);

        dispatch((body.userToFindId ? SearchByFiltersCustom : SearchByFilters)({ option, body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    };

    const {
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:'requests_per_page',
        fixedPagination: false,
        hasContainer:true,
        setIsAllChecked,
        searchElement, //New
        getData,//New
        getDataAdvancedSearch,
        finalArray,
        modified,//New
        setModified,//New
    });

    return {
        t,
        navigate,
        handleDeleteAll,
        permission,
        DEV,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        deletePermission,
        setModified,
        getData
    }
};
